<template>
    <BaseSection
        v-if="scientificProgrammes"
        class="flexible-sections__section scientific-tracks"
    >
        <template #title>
            <h2>{{ title }}</h2>
        </template>

        <template
            v-if="subtitle"
            #subtitle
        >
            <p>{{ subtitle }}</p>
        </template>

        <div class="scientific-tracks__wrapper">
            <BaseCardScientificTracks
                v-for="item in items"
                :key="item.title"
                :url="item.url"
                :color="item.color"
            >
                <template #title>{{ item.title }}</template>

                <template #default>
                    Go to platform <BaseIcon icon="arrow-up-right" />
                </template>
            </BaseCardScientificTracks>
        </div>
    </BaseSection>
</template>

<script setup>

const props = defineProps({
    scientificProgrammes: {
        type: Array,
        required: false,
        default: () => []
    },
    title: {
        type: String,
        required: false,
        default: 'Scientific Programmes'
    },
    subtitle: {
        type: String,
        required: false,
        default: null
    }
});
const items = computed(() => {
    return props.scientificProgrammes.map((scientificProgrammes) => {
        return {
            title: scientificProgrammes.title,
            color: scientificProgrammes.color,
            url: scientificProgrammes.url
        };
    });
});
</script>

<style lang="less">
.scientific-tracks__wrapper {
    .card-grid();

    gap: .5rem !important;// stylelint-disable-line
}
</style>
